import React, { useEffect } from 'react'
import { When } from 'react-if'
import LazyHydrate from 'react-lazy-hydration'
import { slugs } from '@/constants'
import { useRegionContext } from '@/contexts/RegionContext'
import { contentfulFaqLocations, useProjectFaqs } from '@/services/FaqService'
import { Project } from '@/services/ProjectsService'
import { useLocale } from '@/utils/LocaleUtil'
import { useSafeTrack } from '@/utils/analytics'
import { GetStarted } from '@/views/PifExplainerView/GetStarted'
import { HowItWorks } from '@/views/PifExplainerView/HowItWorks'
import { PifHero } from '@/views/PifExplainerView/PifHero'
import { WhyPif } from '@/views/PifExplainerView/WhyPif'
import { FaqSection } from './FaqSection'

interface PifExplainerViewProps {
  projects: Project[]
}

export const PifExplainerView: React.FC<PifExplainerViewProps> = ({ projects }) => {
  const track = useSafeTrack()
  const { locale } = useLocale()
  const { region } = useRegionContext()
  const { faqs, loadingProjectFaqs } = useProjectFaqs({
    region,
    locale,
    preview: false,
    projectSlug: slugs.angelStudios,
    location: contentfulFaqLocations.home,
  })

  useEffect(() => {
    track('PIF Explainer Viewed')
  }, [track])

  return (
    <>
      <div className="min-h-max w-full text-white">
        <PifHero />
        <LazyHydrate whenVisible>
          <WhyPif />
        </LazyHydrate>
        <LazyHydrate whenVisible>
          <HowItWorks />
        </LazyHydrate>
        <LazyHydrate whenVisible>
          <GetStarted
            projects={projects.filter(
              (project) =>
                project?.public && project?.discoveryPosterCloudinaryPath && project?.slug !== slugs.theChosen,
            )}
          />
        </LazyHydrate>
        <LazyHydrate whenVisible>
          <When condition={!loadingProjectFaqs}>
            <FaqSection faqs={faqs} />
          </When>
        </LazyHydrate>
      </div>
    </>
  )
}
